module.exports = __webpack_public_path__ + "img/netmera-logo.d22fd717.svg";